import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";
import type { ElementOrNewElement } from "@/react/types/Element";

import { type BlockMeta, getElementIds } from "../shared/blockUtils";

// Converts a FormContactNameBlock back to a field element
export const blockToElement = (block: BaseBlock): ElementOrNewElement => {
  const meta = block.meta as BlockMeta | undefined;
  const { elementId, elementableId } = getElementIds(block);

  return {
    id: elementId,
    type: "field",
    position: meta?.position ?? 0,
    elementable_id: elementableId,
    parent_element_id: meta?.parentElementId ?? null,
    attributes: {
      field_type: "contact_name",
      label: (block.props.label?.value as string) || "",
      placeholder: (block.props.placeholder?.value as string) || "",
      required: (block.props.required?.value as boolean) || false,
      hidden: (block.props.hidden?.value as boolean) || false,
    },
  } as ElementOrNewElement;
};
